module.exports = __webpack_public_path__ + "static/media/2. Speaker Norhalim Yunus.f4398f56.png";